import { render, staticRenderFns } from "./InvoicesFBATableMobile.vue?vue&type=template&id=66e1dea5&scoped=true"
import script from "./InvoicesFBATableMobile.vue?vue&type=script&lang=js"
export * from "./InvoicesFBATableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e1dea5",
  null
  
)

export default component.exports